import { useNavigate } from 'react-router-dom'
import Pagination from 'components/Pagination/Pagination'
import { trackCtaClick } from 'services/analyticsService'
import { useTranslation } from 'react-i18next'

const PlanejamentoNaIndustria = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const casesDigitalSupplyChain = [
    {
      id: 1,
      title: t(
        'digitalSupplyChainCases_page.casesCardsSupplyChain.cardPrevisaoDeDemanda.title',
      ),
      description: t(
        'digitalSupplyChainCases_page.casesCardsSupplyChain.cardPrevisaoDeDemanda.description',
      ),
      icon: '',
      url: 'previsao-de-demanda',
    },
    {
      id: 2,
      title: t(
        'digitalSupplyChainCases_page.casesCardsSupplyChain.cardAbastecimentoEstoque.title',
      ),
      description: t(
        'digitalSupplyChainCases_page.casesCardsSupplyChain.cardAbastecimentoEstoque.description',
      ),
      icon: '',
      url: 'abastecimento-e-politica-de-estoque',
    },
    {
      id: 3,
      title: t(
        'digitalSupplyChainCases_page.casesCardsSupplyChain.cardConfirmacaoDisponiblidade.title',
      ),
      description: t(
        'digitalSupplyChainCases_page.casesCardsSupplyChain.cardConfirmacaoDisponiblidade.description',
      ),
      icon: '',
      url: 'confirmacao-de-disponibilidade',
    },
    {
      id: 4,
      title: t(
        'digitalSupplyChainCases_page.casesCardsSupplyChain.cardAjusteMalhaLogistica.title',
      ),
      description: t(
        'digitalSupplyChainCases_page.casesCardsSupplyChain.cardAjusteMalhaLogistica.description',
      ),
      icon: '',
      url: 'malha-logistica-no-sistema',
    },
    {
      id: 5,
      title: t(
        'digitalSupplyChainCases_page.casesCardsSupplyChain.cardPlanejamentoOtimizacao.title',
      ),
      description: t(
        'digitalSupplyChainCases_page.casesCardsSupplyChain.cardPlanejamentoOtimizacao.description',
      ),
      icon: '',
      url: 'planejamento-e-otimizacao',
    },
    // {
    //   id: 6,
    //   title: t(
    //     'digitalSupplyChainCases_page.casesCardsSupplyChain.cardPlanejamentoNaIndustrica.title',
    //   ),
    //   description: t(
    //     'digitalSupplyChainCases_page.casesCardsSupplyChain.cardPlanejamentoNaIndustrica.description',
    //   ),
    //   icon: '',
    //   url: 'planejamento-na-industria',
    // },
    {
      id: 7,
      title: t(
        'digitalSupplyChainCases_page.casesCardsSupplyChain.cardProjetoDreams.title',
      ),
      description: t(
        'digitalSupplyChainCases_page.casesCardsSupplyChain.cardProjetoDreams.description',
      ),
      icon: '',
      url: 'projeto-dreams',
    },
    {
      id: 8,
      title: t(
        'digitalSupplyChainCases_page.casesCardsSupplyChain.cardIntegraSAPIBPSupply.title',
      ),
      description: t(
        'digitalSupplyChainCases_page.casesCardsSupplyChain.cardIntegraSAPIBPSupply.description',
      ),
      icon: '',
      url: 'integra-SAP-IBP-supply-chain',
    },
  ]

  const handleRelatedCaseCtaClick = (caseItem) => {
    trackCtaClick({
      cta_name: 'supply_chain_case_related_case_click',
      cta_location: 'digital_supply_chain_case',
      page_name: 'planejamento_na_industria',
      case_title: caseItem.title,
      destination_path: `/${caseItem.url}`,
      cta_text: t('digitalSupplyChainCases_page.saibaMais'),
    })

    navigate(`/${caseItem.url}`)
  }

  return (
    <section className="main-container DataCases">
      <header className="main-container-top">
        <div className="text">
          <h2>{t('digitalSupplyChainCases_page.planejamentoIndustria.title')}</h2>
        </div>
        <div className="image-container">
          <img src="/assets/Cases/DataCases/notebook-datacase2.png" alt="" />
        </div>
      </header>

      <div className="main-content">
        <div className="main-content-primary">
          <h3 className="NoBorder">
            {t(
              'digitalSupplyChainCases_page.abastecimentoPoliticaEstoque.challengeTitle',
            )}
          </h3>
          <ul>
            <li>{t('digitalSupplyChainCases_page.planejamentoIndustria.challenge1')}</li>
            <li>{t('digitalSupplyChainCases_page.planejamentoIndustria.challenge2')}</li>
          </ul>

          <hr />

          <h3>
            {t('digitalSupplyChainCases_page.abastecimentoPoliticaEstoque.approachTitle')}
          </h3>
          <ul>
            <li>{t('digitalSupplyChainCases_page.planejamentoIndustria.approach1')}</li>
            <li>{t('digitalSupplyChainCases_page.planejamentoIndustria.approach2')}</li>
          </ul>

          <hr />

          <h3>
            {t('digitalSupplyChainCases_page.abastecimentoPoliticaEstoque.resultTitle')}
          </h3>
          <ul>
            <li>{t('digitalSupplyChainCases_page.planejamentoIndustria.result1')}</li>
            <li>{t('digitalSupplyChainCases_page.planejamentoIndustria.result2')}</li>
          </ul>

          <img
            src="/assets/cases/DigitalSupplyCases/planejamento na industria.png"
            alt=""
          />
        </div>
      </div>

      <section className="main-cases-container">
        <h2 className="title">{t('digitalSupplyChainCases_page.relatedCasesTitle')}</h2>
        <span className="subtitle">
          {t('digitalSupplyChainCases_page.relatedCasesSubtitle')}
        </span>

        <Pagination data={casesDigitalSupplyChain} itemsPerPage={4}>
          {(currentItems) => (
            <div className="main-cases-content">
              {currentItems.map((caseItem) => (
                <article key={caseItem.id} className="case-card">
                  <span className="icon">{caseItem.icon}</span>
                  <h3>{caseItem.title}</h3>
                  <p>{caseItem.description}</p>
                  <a
                    href={caseItem.link}
                    onClick={() => handleRelatedCaseCtaClick(caseItem)}
                  >
                    {t('digitalSupplyChainCases_page.cta')} →
                  </a>
                </article>
              ))}
            </div>
          )}
        </Pagination>
      </section>
    </section>
  )
}

export default PlanejamentoNaIndustria
